import api from "./api";

export const getCalibrationBoard = (cycleId, params = {}) =>
  api.get(`/cycles/${cycleId}/calibration`, { params });

export const setCalibratedRating = (cycleId, employeeId, payload) =>
  api.patch(`/cycles/${cycleId}/calibration/${employeeId}`, payload);

export const resetCalibratedRating = (cycleId, employeeId) =>
  api.post(`/cycles/${cycleId}/calibration/reset/${employeeId}`);

export const getCalibrationDistribution = (cycleId, params = {}) =>
  api.get(`/cycles/${cycleId}/calibration/distribution`, { params });

export const lockCalibration = (cycleId, payload) => api.post(`/cycles/${cycleId}/calibration/lock`, payload);

export const unlockCalibration = (cycleId) => api.post(`/cycles/${cycleId}/calibration/unlock`);

export const getCalibrationLog = (cycleId) => api.get(`/cycles/${cycleId}/calibration/log`);
